module.exports = __webpack_public_path__ + "static/media/lug-wrench.85967374.svg";